import { Typography } from 'antd';
import {
  CompWithFormProp,
  FormConfigProps,
} from '../../../constants/constants';
import { DynamicFormField } from '../../DynamicFormField';

export const block3EducationMethodsConfig: Record<string, FormConfigProps> = {
  kinestheticMethods: {
    label:
      'naudojamas girdimojo, regimojo ir kinestetinio ugdymo metodų derinys',
    value: 'kinestheticMethods',
  },
  verbalVisialMaterial: {
    label: 'žodinė informacija siejama su vaizdine medžiaga',
    value: 'verbalVisialMaterial',
  },
  visualWithVerbal: {
    label: 'vaizdinė informacija papildoma žodiniu aiškinimu',
    value: 'visualWithVerbal',
  },
  usingIKT: {
    label:
      'naudojamos IKT priemonės padedančios įsisavinti,  įtvirtinti mokomąją medžiagą',
    value: 'usingIKT',
  },
  interactiveMultimediaContent: {
    label:
      'naudojamos mokomosios programos, teikiančios interaktyvų ir daugialypės terpės turinį',
    value: 'interactiveMultimediaContent',
  },
  structuredPrinciples: {
    label: 'taikomi struktūruoto mokymo principai',
    value: 'structuredPrinciples',
  },
  peerTeachingMethod: {
    label: 'taikomas bendraamžių mokymo metodas',
    value: 'peerTeachingMethod',
  },
  cooperativeLearning: {
    label: 'taikomas mokymosi bendradarbiaujant metodas',
    value: 'cooperativeLearning',
  },
  preLearning: {
    label: 'taikoma išankstinio mokymosi strategija',
    value: 'preLearning',
  },
  repetitionAndSystematization: {
    label:
      'taikomos kartojimo, plėtojimo, informacijos sisteminimo strategijos',
    value: 'repetitionAndSystematization',
  },
  smallGroups: {
    label:
      'epizodiškai taikomas ugdymas mažoje grupėje, pagalba teikiama specialiojo pedagogo kabinete',
    value: 'smallGroups',
  },
  providedInStages: {
    label: 'informacija pateikiama etapais / dalimis',
    value: 'providedInStages',
  },
  analysisViaGraphicOrganizer: {
    label:
      'informacijos  analizė atliekama pildant numatytą grafinę tvarkyklę / mąstymo žemėlapį',
    value: 'analysisViaGraphicOrganizer',
  },
  supplementedVerbalInstructions: {
    label: 'žodinės instrukcijos papildomos vaizdine informacija / simboliais',
    value: 'supplementedVerbalInstructions',
  },
  multipleInstructions: {
    label: 'užduotys iš kelių ar daugiau nurodymų pateikiamos etapais',
    value: 'multipleInstructions',
  },
  termsVocabulary: {
    label:
      'formuojant / plėtojant dalyko žodyną sistemingai pildomas sąvokų / terminų žodynėlis',
    value: 'termsVocabulary',
  },
  readingStrategies: {
    label: 'taikomos skaitymo strategijos',
    value: 'readingStrategies',
  },
  writingStrategies: {
    label: 'taikomos rašymo strategijos',
    value: 'writingStrategies',
  },
  linkedToRealLife: {
    label:
      'dalyko turinys siejamas su realiu gyvenimu (praktiniu pritaikomumu)',
    value: 'linkedToRealLife',
  },
};

export const EducationMethods = ({ form }: CompWithFormProp) => {
  return (
    <>
      <Typography.Title
        style={{ marginTop: 0, marginBottom: 34, fontWeight: 'normal' }}
        level={4}
      >
        Pamokoje naudojami ugdymo būdai ir metodai:
      </Typography.Title>
      <DynamicFormField
        formItemConfig={block3EducationMethodsConfig}
        formPathParams={['subject', 'block3', 'methods']}
        form={form}
      />
    </>
  );
};
